import { render, staticRenderFns } from "./l-type-admission.html?vue&type=template&id=0816057e&scoped=true&external"
import script from "./l-type-admission.js?vue&type=script&lang=js&external"
export * from "./l-type-admission.js?vue&type=script&lang=js&external"
import style0 from "./l-type-admission.scss?vue&type=style&index=0&id=0816057e&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0816057e",
  null
  
)

export default component.exports